<template>
  <div class="fb-container" v-if="documentData">
    <div class="fb-container-header" @click="handleBack">返回报告首页</div>
    <div class="fb-container-content">
      <div v-if="documentData" class="fb-detail">
        <div class="result_wrap">
          <div class="result_basis">
            <div class="basis_title">
              <p>基本信息</p>
            </div>
            <div class="basis_cell">
              <div class="basis_item basis_45">
                身高：
                <p>{{ documentData.base.height }}cm</p>
              </div>
              <div class="basis_item basis_45">
                体重：
                <p>{{ documentData.base.weight }}kg</p>
              </div>
              <div class="basis_item basis_45">
                腰围：
                <p>{{ documentData.base.waist ? `${documentData.base.waist}cm` : '--' }}</p>
              </div>
              <div class="basis_item basis_45">
                臀围：
                <p>{{ documentData.base.hip ? `${documentData.base.hip}cm` : '--' }}</p>
              </div>
            </div>
          </div>
          <div class="result_fb">
            <div class="basis_title">
              骨折的风险概率
            </div>
            <div class="basis_p">
              (如果发生骨折，身体各部位发生骨折的风险概率）
            </div>
            <div class="fb_wrap">
              <div class="man_wrap">
                <img class="man_img" :src="`${imgHost}/fb/gz-man.png`" />
                <div class="human-head">
                  <div :class="siteMax === documentData.fb_detail.site.site1 ? 'icon-red' : 'icon-blue'"></div>
                  <div class="line"></div>
                  <div class="value">
                    头部
                    <p :class="siteMax === documentData.fb_detail.site.site1 ? 'value-p' : ''">
                      {{ documentData.fb_detail.site.site1 }}%
                    </p>
                  </div>
                </div>
                <div class="human-vertebra">
                  <div class="value">
                    颈椎部
                    <p :class="siteMax === documentData.fb_detail.site.site2 ? 'value-p' : ''">
                      {{ documentData.fb_detail.site.site2 }}%
                    </p>
                  </div>
                  <div class="line"></div>
                  <div :class="siteMax === documentData.fb_detail.site.site2 ? 'icon-red' : 'icon-blue'"></div>
                </div>
                <div class="human-limb">
                  <div :class="siteMax === documentData.fb_detail.site.site3 ? 'icon-red' : 'icon-blue'"></div>
                  <div class="line"></div>
                  <div class="value">
                    上肢
                    <p :class="siteMax === documentData.fb_detail.site.site3 ? 'value-p' : ''">
                      {{ documentData.fb_detail.site.site3 }}%
                    </p>
                  </div>
                </div>
                <div class="human-legs">
                  <div class="value">
                    下肢
                    <p :class="siteMax === documentData.fb_detail.site.site4 ? 'value-p' : ''">
                      {{ documentData.fb_detail.site.site4 }}%
                    </p>
                  </div>
                  <div class="line"></div>
                  <div :class="siteMax === documentData.fb_detail.site.site4 ? 'icon-red' : 'icon-blue'" />
                </div>
              </div>
              <div class="gz-distribution">
                <div class="item">
                  <img :src="siteMax === documentData.fb_detail.site.site1
                    ? `${imgHost}/fb/gz-tb-red.png`
                    : `${imgHost}/fb/gz-tb.png`
                    " class="item-img" />

                  <div class="item-info">
                    <p class="title">
                      头部
                    </p>
                    <p :class="siteMax === documentData.fb_detail.site.site1 ? 'value-p' : 'value'">
                    <p class="span">
                      {{ documentData.fb_detail.site.site1 }}
                    </p>
                    %
                    </p>
                  </div>
                </div>
                <div class="item">
                  <img :src="siteMax === documentData.fb_detail.site.site2
                    ? `${imgHost}/fb/gz-jz-red.png`
                    : `${imgHost}/fb/gz-jz.png`
                    " class="item-img" />

                  <div class="item-info">
                    <p class="title">
                      颈椎部
                    </p>
                    <p :class="siteMax === documentData.fb_detail.site.site2 ? 'value-p' : 'value'">
                    <p class="span">
                      {{ documentData.fb_detail.site.site2 }}
                    </p>
                    %
                    </p>
                  </div>
                </div>
                <div class="item">
                  <img :src="siteMax === documentData.fb_detail.site.site3
                    ? `${imgHost}/fb/gz-sz-red.png`
                    : `${imgHost}/fb/gz-sz.png`
                    " class="item-img" />
                  <div class="item-info">
                    <p class="title">
                      上肢
                    </p>
                    <p :class="siteMax === documentData.fb_detail.site.site3 ? 'value-p' : 'value'">
                    <p class="span">
                      {{ documentData.fb_detail.site.site3 }}
                    </p>
                    %
                    </p>
                  </div>
                </div>
                <div class="item">
                  <img :src="siteMax === documentData.fb_detail.site.site4
                    ? `${imgHost}/fb/gz-xz-red.png`
                    : `${imgHost}/fb/gz-xz.png`
                    " class="item-img" />
                  <div class="item-info">
                    <p class="title">
                      下肢
                    </p>
                    <p :class="siteMax === documentData.fb_detail.site.site4 ? 'value-p' : 'value'">
                    <p class="span">
                      {{ documentData.fb_detail.site.site4 }}
                    </p>
                    %
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="result-left">
          <div v-if="gzStatus !== -1" class="gz-status">
            <div class="gz-title">
              骨质状况分析
            </div>
            <div class="gz-status-list">
              <div v-for="(item, index) in gzStatusList" :key="item.src" class="gz-item">
                <img :src="item.src" :class="gzStatus === index ? 'gz-img active' : 'gz-img'" />
                <div :class="gzStatus === index ? 'gz-p p-active' : 'gz-p'">
                  <p>{{ item.title }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="gz-probability">
            <div class="gz-title">
              未来骨折风险概率
            </div>
            <div class="gz-list">
              <div class="gz-five">
                <div class="five-title">
                  未来五年
                </div>
                <div class="qjc-flex five-item">
                  <p class="five-item-title">
                    骨折的风险概率
                  </p>
                  <label class="five-slider">
                    <xx-slider :rates="fSlider.sliderValue" />
                  </label>
                </div>
                <div class="qjc-flex five-item qjc-flex-alc">
                  <p class="five-item-title">
                    骨折复发的风险概率
                  </p>
                  <label class="five-slider">
                    <xx-slider :rates="fSlider.sliderValue2" />
                  </label>
                </div>
                <div class="qjc-flex qjc-flex-alc five-item">
                  <p class="five-item-title">
                    骨折复发多次风险概率
                  </p>
                  <label class="five-slider">
                    <xx-slider :rates="fSlider.sliderValue3" />
                  </label>
                </div>
              </div>
              <div class="gz-five ten-years">
                <div class="five-title">
                  未来十年
                </div>
                <div class="qjc-flex five-item">
                  <p class="five-item-title">
                    骨折的风险概率
                  </p>
                  <label class="five-slider">
                    <xx-slider :rates="tSlider.sliderValue" />
                  </label>
                </div>
                <div class="qjc-flex qjc-flex-alc five-item">
                  <p class="five-item-title">
                    骨折复发的风险概率
                  </p>
                  <label class="five-slider">
                    <xx-slider :rates="tSlider.sliderValue2" />
                  </label>
                </div>
                <div class="qjc-flex qjc-flex-alc five-item">
                  <p class="five-item-title">
                    骨折复发多次风险概率
                  </p>
                  <label class="five-slider">
                    <xx-slider :rates="tSlider.sliderValue3" />
                  </label>
                </div>
              </div>
            </div>
          </div>




        </div>
        <div>
          <div class="gz-mortality">
            <div class="gz-title">
              因骨折导致严重伤害的风险概率
            </div>
            <div class="gz-content">
              <div class="gz-wrap">
                <!-- 骨折死亡率echart图表 -->
                <div class="costs-chart-gz">
                  <div class="costs-chart-gz container">
                    <u-chart :rate="documentData.fb_detail.death.fd05" />
                  </div>
                </div>

                <div class="qjc-flex gz-mortality-tip">
                  <div>注：</div>
                  <div class="">
                    <p>年龄小于65岁：仅显示5年内的因骨折导致严重伤害的风险概率</p>
                    <p>年龄65～74岁：显示3，5年内的因骨折导致严重伤害的风险概率；</p>
                    <p>年龄75岁以上：显示2，3，5年内的因骨折导致严重伤害的风险概率</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gz-title mt-5">
            骨密度改善建议
          </div>

          <div class="gz-mortality-suggestion" hover-class="none" :hover-stop-propagation="false">
            <div class="gz-mortality-suggestion-tip" hover-class="none" :hover-stop-propagation="false">
              依据您的年龄、性别、生活习惯等情况，提供关于骨密度改善的建议如下：
            </div>
            <div v-for="(item, index) in documentData.fb_detail.sugg.supp || []" :key="index"
              class="gz-mortality-suggestion-item" hover-class="none" :hover-stop-propagation="false">
              {{ index + 1 }}. {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        暂无数据
      </div>

    </div>

  </div>
</template>

<script>
import { getReportDetail } from '@/utils/axios';
import { imgHost2, imgHost } from '@/config';
import xxSlider from '@/components/xx-slider/index.vue';
import uChart from '@/components/u-chart/index.vue';


export default {
  name: 'HaleonBackDetailFb',
  components: {
    xxSlider, uChart
  },
  data () {
    return {
      documentData: null,
      imgHost2, imgHost,
      siteMax: "",
      isPopup: false
    };
  },

  mounted () {
    const id = this.$route.query.id;
    console.log("detail page id: ", id);
    if (id) {
      this.getDetail(id);
    }
    this.isPopup = true
  },

  computed: {
    gzStatus () {
      const tscore = this.documentData.base.tscore
      console.log('tscore', tscore)

      if (tscore === undefined || tscore === '') {
        return -1
      }
      else if (Number(tscore) > -1) {
        return 0
      }
      else if (Number(tscore) <= -2.5) {
        return 2
      }
      else {
        return 1
      }
    },
    gzStatusList () {
      return [
        { src: `${imgHost}/fb/gz-zz.png`, title: '骨质正常' },
        { src: `${imgHost}/fb/gz-bz.png`, title: '骨质不足' },
        { src: `${imgHost}/fb/gz-ss.png`, title: '骨质疏松' },
      ]
    },
    fSlider () {
      return {
        sliderValue: [
          Number(this.documentData.fb_detail.fx.f5a || 0) * 10,
          Number(this.documentData.fb_detail.fx.f5b) * 10,
        ],
        sliderValue2: [
          Number(this.documentData.fb_detail.rfx.rf52a) * 10,
          Number(this.documentData.fb_detail.rfx.rf52b) * 10,
        ],
        sliderValue3: [
          Number(this.documentData.fb_detail.rfx.rf53a) * 10,
          Number(this.documentData.fb_detail.rfx.rf53b) * 10,
        ],
      }
    },
    tSlider () {
      return {
        sliderValue: [
          Number(this.documentData.fb_detail.fx.f10a) * 10,
          Number(this.documentData.fb_detail.fx.f10b) * 10,
        ],
        sliderValue2: [
          Number(this.documentData.fb_detail.rfx.rf102a) * 10,
          Number(this.documentData.fb_detail.rfx.rf102b) * 10,
        ],
        sliderValue3: [
          Number(this.documentData.fb_detail.rfx.rf103a) * 10,
          Number(this.documentData.fb_detail.rfx.rf103b) * 10,
        ],
      }
    }
  },

  methods: {
    getDetail (id) {
      getReportDetail({ id }).then(res => {
        if (res.code === 200) {
          const data = JSON.parse(window.atob(res.data));
          console.log(data);
          this.documentData = data;
        } else {
          console.log(res.msg);
        }
      })
    },
    handleBack () {
      this.$router.replace({ name: 'archivesDetailIndex', query: { id: this.$route.query.id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.fb-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto auto 1fr;
  overflow: hidden;
  gap: 10px;
  padding: 10px;
  background-color: #F2F4FA;

  >div {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  &-header {
    background-color: #e2e2e2;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: bold;
    user-select: none;
    cursor: pointer;
    color: #000;
  }

  &-content {



    .fb-detail {
      position: relative;
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 100%;
      gap: 10px;
      overflow: hidden;



      >div {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #fff;
        padding: 10px;
        overflow-y: auto;
      }
    }

    .result_wrap {
      width: 100%;
      height: 100%;
      color: #777f8f;
      padding: 12px;
      background-color: #ffffff;
    }

    .basis_title {
      font-family:
        PingFangSC-Medium,
        PingFang SC;
      font-size: 17px;
      color: #333;
      text-align: left;
    }

    .result_basis .basis_title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      font-size: 17px;
      color: #333;
      text-align: left;
    }

    .basis_more {
      color: #575d69;
      font-family: PingFang SC;
      font-size: 12px;
      line-height: 12px;
    }

    .basis_cell {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      flex-wrap: wrap;
      margin-bottom: 20px;
    }

    .basis_item {
      width: 30%;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #6883fb;
      border-radius: 20px;
      margin-top: 10px;
      font-size: 12px;
    }

    .basis_item:nth-child(2n + 1) {
      margin-right: 20px;
    }

    .basis_45 {
      width: 45%;
    }

    .basis_item text {
      color: #333;
    }

    .basis_text {
      font-size: 12px;
      color: #777f8f;
      text-align: left;
      padding: 5px 0;
    }

    .fb_wrap {
      width: 100%;
      padding: 8px;
      border: 1px solid #e8eaf0;
      border-radius: 6px;
      margin-top: 5px;
    }

    .man_wrap {
      position: relative;
      width: 100px;
      height: 520px;
      margin: 12px auto 0;
    }

    .man_img {
      width: 100px;
      height: 100%;
    }

    .human-head {
      position: absolute;
      top: 5px;
      left: 43px;
      display: flex;
      align-items: center;
    }

    .human-head .value {
      width: 75px;
      font-size: 15px;
      color: #777f8f;
    }

    .human-head p {
      color: #3b4549;
    }

    .human-head .line {
      width: 73px;
      height: 1px;
      background-color: #bcced5;
    }

    .human-head-icon {
      width: 16px;
      height: 16px;
    }

    .human-vertebra {
      position: absolute;
      top: 60px;
      left: -170px;
      display: flex;
      align-items: center;
    }

    .human-vertebra .line {
      width: 110px;
      height: 1px;
      background-color: #bcced5;
    }

    .human-vertebra .value {
      width: 100px;
      font-size: 15px;
      color: #777f8f;
      padding-right: 5px;
      text-align: right;
    }

    .human-vertebra p {
      color: #3b4549;
    }

    .human-vertebra .value-text {
      color: #ec4f4f;
    }

    .human-limb {
      position: absolute;
      top: 130px;
      left: 83px;
      display: flex;
      align-items: center;
    }

    .human-limb .line {
      width: 36px;
      height: 1px;
      background-color: #bcced5;
    }

    .human-limb .value {
      width: 75px;
      font-size: 15px;
      color: #777f8f;
    }

    .human-limb p {
      color: #3b4549;
    }

    .human-limb .value-text {
      color: #ec4f4f;
    }

    .human-legs {
      position: absolute;
      top: 410px;
      left: -90px;
      display: flex;
      align-items: center;
    }

    .human-legs .line {
      width: 15px;
      height: 1px;
      background-color: #bcced5;
    }

    .human-legs .value {
      width: 100px;
      font-size: 15px;
      color: #777f8f;
      padding-right: 5px;
      text-align: right;
    }

    .human-legs text {
      color: #3b4549;
    }

    .human-legs .value-text {
      color: #ec4f4f;
    }

    .icon-blue {
      width: 16px;
      height: 16px;
      border: 4px solid #b3bcf0;
      background-color: #6883fb;
      border-radius: 50%;
    }

    .icon-red {
      width: 16px;
      height: 16px;
      border: 4px solid #daa4aa;
      background-color: #ee3f3f;
      border-radius: 50%;
    }

    .gz-distribution {
      position: relative;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 10px;
      margin-top: 20px;
    }

    .gz-distribution .item {
      display: flex;
      align-items: center;
      width: calc(50% - 10px);
      height: 75px;
      padding: 0 10px;
      margin-bottom: 8px;
      border: 1px solid #e8eaf0;
      border-radius: 6px;
    }

    .gz-distribution .item-img {
      width: 77px;
      height: 52px;
    }

    .gz-distribution .item-info {
      font-size: 12px;
      text-align: center;
      flex: 1;
    }

    .gz-distribution .title {
      margin-bottom: 5px;
    }

    .gz-distribution .value {
      color: #3b4549;
    }

    .gz-distribution .value .span {
      font-size: 22px;
      color: #3b4549;
    }

    .gz-distribution .value-text {
      color: #ec4f4f !important;
    }

    .gz-distribution .value-text .span {
      font-size: 22px;
    }

    .gz-status .gz-title {
      font-family:
        PingFangSC-Medium,
        PingFang SC;
      font-size: 17px;
      color: #3b4549;
      text-align: left;
      margin-top: 24px;
      padding: 0 0 11px;
    }

    .gz-status .gz-list {
      display: flex;
      justify-content: space-between;
      /* padding: 0; */
      box-sizing: border-box;
    }

    .gz-status .gz-text {
      font-size: 15px;
      color: #777f8f;
      margin-top: 5px;
      box-sizing: border-box;
      font-weight: 400;
      line-height: 17px;
      text-align: center;
    }

    .gz-probability .gz-title {
      font-family:
        PingFangSC-Medium,
        PingFang SC;
      font-size: 17px;
      color: #3b4549;
      text-align: left;
      padding: 0 0 11px;
      margin-top: 24px;
      line-height: 17px;
    }

    .gz-probability .gz-list {
      padding: 0;
    }

    .gz-probability .gz-five {
      padding: 20px 10px;
      border-radius: 6px;
      border: 1px solid #e8eaf0;
    }

    .gz-five .five-title {
      font-size: 15px;
      font-family:
        PingFangSC-Medium,
        PingFang SC;
      font-weight: 500;
      color: #6883fb;
      padding-top: 2px;
      text-align: left;
    }

    .gz-five .five-slider {
      flex: 1;
      margin-left: 20px;
      margin-top: 5px;
    }

    .gz-five .five-item {
      margin-top: 20px;
    }

    .gz-five .five-item-title {
      width: 120px;
      font-size: 12px;
      color: #777f8f;
      text-align: left;
    }

    .gz-five .five-item-val {
      font-size: 17px;
      color: #3b4549;
      text-align: left;
      margin-top: 3px;
    }

    .ten-years {
      margin-top: 16px;
    }

    .qjc-flex {
      display: flex;
    }

    .qjc-flex-alc {
      align-items: center;
    }

    .gz-mortality .gz-title {
      font-family:
        PingFangSC-Medium,
        PingFang SC;
      font-size: 17px;
      color: #3b4549;
      text-align: left;
      /* padding: 0 0.24rem; */
      margin-top: 43px;
      font-weight: 500;
    }

    .gz-mortality .gz-content {
      /* padding: 0 0.24rem; */
      margin-top: 5px;
    }

    .gz-mortality .gz-wrap {
      padding: 8px;
      border: 1px solid #e8eaf0;
      border-radius: 6px;
    }

    .gz-mortality .costs-chart-gz {
      height: 300px;
    }

    .gz-mortality .gz-mortality-tip {
      font-size: 12px;
      color: #777f8f;
      text-align: left;
      padding-left: 6px;
      margin-bottom: 10px;
    }

    .gz-mortality p {
      line-height: 21px;
      display: block;
    }

    .gz-mortality .container {
      width: 100%;
      height: 300px;
      padding: 0;
    }

    .gz-proposal {
      padding: 0 0 30px;
      margin-top: 36px;
    }

    .gz-proposal .btn {
      position: relative;
      width: 351px;
      height: 97px;
      padding: 0 12px;
      justify-content: space-between;
      border-radius: 8px;
      /* background: url(../../assets/images/proposal-btn-bg.jpg) no-repeat; */
      /* background-size: 100% 100%; */
    }

    .gz-proposal .btn-title {
      position: relative;
      font-size: 17px;
      color: #fff;
      font-weight: 500;
      z-index: 3;
    }

    .proposal_bg {
      position: absolute;
      width: 351px;
      height: 97px;
      top: 0;
      left: 0;
    }

    .arrow_icon {
      width: 20px;
      height: 20px;
      z-index: 3;
    }

    .tscore_wrap {
      width: 100%;
      padding: 15px 8px;
      border: 1px solid #e8eaf0;
      border-radius: 6px;
      margin-top: 16px;
    }

    .tscore_title {
      font-size: 15px;
      font-family:
        PingFangSC-Medium,
        PingFang SC;
      font-weight: 500;
      color: #6883fb;
    }

    .tscore_box {
      width: 100%;
      padding: 5px 12px;
      background: #edf1fa;
      border-radius: 6px;
      margin-top: 16px;
    }

    .tscore_tips {
      display: block;
      font-size: 14px;
      font-family:
        PingFangSC-Regular,
        PingFang SC;
      font-weight: 400;
      color: #3b4549;
      line-height: 24px;
      position: relative;
    }

    .tscore_tip {
      display: block;
      font-size: 14px;
      font-family:
        PingFangSC-Regular,
        PingFang SC;
      font-weight: 400;
      color: #3b4549;
      line-height: 24px;
      position: relative;
      padding-left: 10px;
    }

    .tscore_tip::before {
      position: absolute;
      top: 10px;
      left: 2px;
      content: '';
      width: 2px;
      height: 2px;
      background-color: #333;
      border-radius: 50%;
    }

    .tscore_btn {
      width: 100%;
      height: 36px;
      font-size: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family:
        PingFangSC-Regular,
        PingFang SC;
      font-weight: 400;
      color: #ffffff;
      background: #6883fb;
      border-radius: 4px;
      margin-top: 21px;
    }

    .popup {
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 10000;
    }

    .popup_wrap {
      position: relative;
      width: 81%;
      padding: 21px 24px;
      border-radius: 4px;
      background-color: #fff;
      margin-bottom: 120px;
    }

    .popup_title {
      font-size: 14px;
      font-family:
        PingFangSC-Medium,
        PingFang SC;
      font-weight: 500;
      color: #323232;
      line-height: 20px;
      text-align: center;
    }

    .popup_input {
      width: 100%;
      height: 74px;
      border-radius: 3px;
      border: 1px solid #d1d6e3;
      margin-top: 16px;
      font-size: 14px;
      font-family:
        PingFangSC-Regular,
        PingFang SC;
      font-weight: 400;
      padding: 0 12px;
      color: #333;
    }

    .popup_btn {
      width: 100%;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 33px;
      font-family:
        PingFangSC-Medium,
        PingFang SC;
      font-weight: 500;
      color: #ffffff;
      background: #6883fb;
      border-radius: 4px;
      margin-top: 25px;
    }

    .close_cell {
      position: absolute;
      bottom: -110px;
      left: 0;
      width: 100%;
      text-align: center;
    }

    .close_img {
      width: 36px;
      height: 36px;
    }

    .gz-mortality-suggestion {
      position: relative;
      width: 100%;
      padding: 6px;
      border-radius: 8px;
      border: 1px solid #e8eaf0;
      margin-top: 20px;
      color: #222;
      line-height: 24px;

      &-tip {
        color: #666;
        font-size: 14px;
        line-height: 33px;
        margin-bottom: 5px;
      }
    }

    .gz-status {
      position: relative;
      width: 100%;
      overflow: hidden;
    }

    .gz-status-list {
      position: relative;
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 5px;

      >div {
        position: relative;
        width: 100%;
        height: 100%;
        white-space: nowrap;
        overflow: hidden;

        .gz-img {
          width: 100%;
          border: 1px solid #e8eaf0;
          border-radius: 6px;
          box-sizing: border-box;
        }
      }

      .gz-item .active {
        border: 2px solid #6883fb;
        border-radius: 6px;
        box-sizing: border-box;
      }

      .gz-item .text-active {
        color: #6883fb;
        font-weight: 500;
      }
    }
  }
}
</style>